<template>
  <v-btn :class="buttonClass" @click="clickTime" depressed>{{simpleTime(time)}}</v-btn>
</template>

<script>
import { Mixins } from '@homegauge/vue';

const { DateTime } = Mixins;

export default {
  props: {
    selectedTime: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      required: true,
    },
  },
  mixins: [DateTime],
  computed: {
    buttonClass() {
      return {
        'time-button': true,
        selected: this.time === this.selectedTime,
        unselected: this.time !== this.selectedTime,
      };
    },
  },
  methods: {
    clickTime() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/calendar';
@import '../styles/vars/typography';

.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  &.time-button {
    background-color: $calendar-button-background;
    box-shadow: none;
    color: $calendar-button-color;
    font-size: $calendar-button-font-size;
    font-weight: $typography-weight-bold;
    letter-spacing: $calendar-button-letter-spacing;
    margin: 0;
    width: 100%;

    &.selected {
      background-color: $calendar-button-selected-background;
      color: $calendar-button-selected-color;
    }
  }
}
</style>
